// InspectorEditableBlock.tsx
import React from "react";
import {
    standardMappingSchema,
    volumeMappingSchema,
    bxgyMappingSchema,
    bundleBuilderMappingSchema,
    mixMatchMappingSchema,
    mixMatchSectionalMappingSchema,
    fbtMappingSchema,
    slideCartMappingSchema,
    productAddonsMappingSchema,
    productAddonsPopupMappingSchema,
    thankYouPageMappingSchema,
    buyNMappingSchema,
    bbPlaceholderMappingSchema,
} from "../../mappings";

const schemaMap = {
    standard: standardMappingSchema,
    volume: volumeMappingSchema,
    bxgy: bxgyMappingSchema,
    mixmatch: mixMatchMappingSchema,
    mixmatch_sectional: mixMatchSectionalMappingSchema,
    fbt: fbtMappingSchema,
    product_add_on: productAddonsMappingSchema,
    bundle_builder: bundleBuilderMappingSchema,
    slideCart: slideCartMappingSchema,
    thankYouPage: thankYouPageMappingSchema,
    product_add_on_popup: productAddonsPopupMappingSchema,
    buy_n: buyNMappingSchema,
    bb_placeholder: bbPlaceholderMappingSchema,
} as const;
type BundleType = keyof typeof schemaMap;

interface InspectorEditableBlockProps {
    bundleType: BundleType | string | undefined;
    settingKey: string;
    children: React.ReactNode;
    wrapWithDiv?: boolean;
    tagsKey?: string;
    productId?: string;
}

interface SchemaItem {
    tabId: string;
    sectionId: string;
    label: string;
}

export function InspectorEditableBlock({
    bundleType,
    settingKey,
    children,
    wrapWithDiv = false,
    tagsKey,
    productId,
}: InspectorEditableBlockProps) {
    if (bundleType === undefined) return <>{children}</>;

    const schema = schemaMap[bundleType] as Record<string, SchemaItem>;
    const config = schema?.[settingKey];

    if (!config) {
        console._log(`InspectorEditableBlock: schema not found for ${bundleType}.${settingKey}`);
        return <>{children}</>;
    }

    const dataAttrs = {
        "data-settings": `${config.tabId}:${config.sectionId}`,
        "data-label": config.label,
        "data-tags": tagsKey,
        "data-product-id": productId,
    };

    if (wrapWithDiv) {
        return (
            <div
                style={{
                    width: "100%",
                    position: "relative",
                }}
                {...dataAttrs}
            >
                {children}
            </div>
        );
    }

    return React.isValidElement(children) ? React.cloneElement(children, dataAttrs) : children;
}
